import { useMutation } from "@tanstack/react-query";
import { concludeEssay } from "../../queries/EssaySchedule";
import { useEssayScheduleStore } from "../../stores/essayScheduleStore";

export const useConcludeScheduleEssayHook = () => {
    const { setEssaySchedule } = useEssayScheduleStore();

    const { mutate, data, isError, isSuccess } = useMutation({
        mutationKey: ['conclude-schedule-essay'],
        mutationFn: (body: { cronogramaId: string, essayThemeId: string }) => concludeEssay(body),
        onSuccess: () => {
            setEssaySchedule(null);
        },
        retry: false
    });

    return { finishEssay: mutate, data, isError, isSuccess };
};